<template>
  <div>
    <b-card header="Relatório de Denúncias Martinelli">
      <b-form @submit.prevent="handleSubmit">
        <b-form-group label="Período do Relatório">
          <b-row>
            <b-col cols="6">
              <label class="small text-muted">Data Inicial</label>
              <b-form-input
                id="start-date"
                v-model="form.startDate"
                type="date"
                :state="validateStartDate"
                required
              ></b-form-input>
              <b-form-invalid-feedback>
                Campo obrigatório
              </b-form-invalid-feedback>
            </b-col>
            <b-col cols="6">
              <label class="small text-muted">Data Final</label>
              <b-form-input
                id="end-date"
                v-model="form.endDate"
                type="date"
                :state="validateEndDate"
                required
              ></b-form-input>
              <b-form-invalid-feedback>
                A data final deve ser posterior à data inicial
              </b-form-invalid-feedback>
            </b-col>
          </b-row>
        </b-form-group>

        <b-form-group
          v-if="showCompanySelector"
          label="Empresa"
          label-for="company-select"
        >
          <b-form-select
            id="company-select"
            v-model="form.companyId"
            :options="companyOptions"
          ></b-form-select>
        </b-form-group>

        <b-form-group label="Idioma do Relatório" label-for="language-select">
          <b-form-select
            id="language-select"
            v-model="form.language"
            :options="languageOptions"
          ></b-form-select>
        </b-form-group>

        <b-row class="mt-4">
          <b-col>
            <b-button
              variant="primary"
              type="submit"
              :disabled="loading || !isFormValid"
            >
              <b-spinner v-if="loading" small class="mr-1"></b-spinner>
              <i v-else class="fas fa-file-word mr-2" aria-hidden="true"></i>
              {{ loading ? "Gerando..." : "Gerar Relatório" }}
            </b-button>
          </b-col>
        </b-row>
      </b-form>
    </b-card>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { getCompanies } from "../../api/company";
import {
  generateComplaintsReportDocx,
  downloadReportBlob,
} from "../../api/reports";

export default {
  name: "DocxReportView",
  data() {
    return {
      loading: false,
      companies: [],
      form: {
        startDate: "",
        endDate: "",
        companyId: null,
        language: "pt",
      },
      languageOptions: [
        { value: "pt", text: "Português" },
        { value: "en", text: "English" },
        { value: "es", text: "Español" },
      ],
    };
  },
  computed: {
    ...mapGetters(["profile"]),
    showCompanySelector() {
      console.log(this.profile, this.companies);
      return (
        (this.profile.role === "root" ||
          this.profile.role === "company-root") &&
        this.companies.length > 0
      );
    },
    companyOptions() {
      const options = [];
      this.companies.forEach((company) => {
        options.push({
          value: company._id,
          text: company.fantasyName || company.name,
        });
      });
      return options;
    },
    validateStartDate() {
      if (!this.form.startDate) return null;
      return this.form.startDate.length > 0;
    },
    validateEndDate() {
      if (!this.form.endDate) return null;
      if (!this.form.startDate) return true;
      return new Date(this.form.endDate) >= new Date(this.form.startDate);
    },
    isFormValid() {
      return (
        this.form.startDate &&
        this.form.endDate &&
        new Date(this.form.endDate) >= new Date(this.form.startDate)
      );
    },
  },
  async mounted() {
    this.resetForm();
    if (this.profile.role === "root" || this.profile.role === "company-root") {
      await this.fetchCompanies();
    }
  },
  methods: {
    resetForm() {
      const today = new Date();
      const firstDayOfMonth = new Date(
        today.getFullYear(),
        today.getMonth(),
        1
      );

      this.form = {
        startDate: this.formatDateForInput(firstDayOfMonth),
        endDate: this.formatDateForInput(today),
        companyId: null,
        language: "pt",
      };
      this.loading = false;
    },
    formatDateForInput(date) {
      return date.toISOString().split("T")[0];
    },
    async fetchCompanies() {
      try {
        const response = await getCompanies({ size: 1000, page: 1 });
        this.companies = response.data.docs || response.data || [];
      } catch (error) {
        console.error("Error fetching companies:", error);
      }
    },
    async handleSubmit() {
      if (!this.isFormValid) {
        return;
      }

      this.loading = true;

      try {
        const params = {
          startDate: this.form.startDate,
          endDate: this.form.endDate,
          language: this.form.language,
        };

        if (this.form.companyId) {
          params.companyId = this.form.companyId;
        }

        const response = await generateComplaintsReportDocx(params);

        // Generate filename
        const filename = `relatorio-denuncias-${this.form.startDate}-${this.form.endDate}.pdf`;

        // Download the file
        downloadReportBlob(response, filename);

        this.$bvToast.toast("Relatório gerado com sucesso!", {
          title: "Sucesso",
          variant: "success",
          solid: true,
        });
      } catch (error) {
        console.error("Error generating report:", error);
        this.$bvToast.toast(
          "Erro ao gerar o relatório. Por favor, tente novamente.",
          {
            title: "Erro",
            variant: "danger",
            solid: true,
          }
        );
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>
